import { timelineSeed } from "./timeline_seed";

const maria = { id: "fixture-maria", label: "Μαρία Παπαδοπούλου" };
const nikos = { id: "fixture-nikos", label: "Νίκος Γεωργίου" };

// Anonymized activity-view fixtures; the original all-scenarios timeline stays available.
export const legacyActivitySeed = [
    ...timelineSeed.filter((event) => ["brand-created", "sales-session-sass"].includes(event.id)).map((event) => (
        event.type === "SALES_SESSION"
            ? { ...event, detail: { ...event.detail, seller: event.actor } }
            : event
    )),
    {
        id: "activity-maria-2026-03-25",
        type: "LEGACY_ACTIVITY",
        app: "niffler",
        at: Date.parse("2026-03-25T14:15:00Z"),
        actor: maria,
        detail: {
            day: "2026-03-25",
            events: [
                { id: "legacy-comment-1", type: "COMMENT", at: Date.parse("2026-03-25T08:45:00Z"), text: "Δεν μπορούσε να μιλήσει εκείνη τη στιγμή και μου ζήτησε να τον καλέσω ξανά μετά τη συνάντηση.\nΕνδιαφέρεται για περισσότερες πληροφορίες σχετικά με την υπηρεσία, αλλά θέλει πρώτα να συζητήσει τις επιλογές με τη συνεργάτιδά του." },
                { id: "legacy-edit-1", type: "BRAND_UPDATE", at: Date.parse("2026-03-25T09:10:00Z"), changes: [["brand", "ALPHA STUDIO", "ALPHA HEALTH STUDIO"], ["firstName", "Maria", "Μαρία"]] },
                { id: "legacy-meeting-1", type: "MEETING", at: Date.parse("2026-03-25T14:15:00Z"), detail: { schedule: "2026-03-27T09:00:00Z" }, text: "Η συνάντηση επιβεβαιώθηκε τηλεφωνικά." }
            ]
        }
    },
    {
        id: "activity-nikos-2026-03-25",
        type: "LEGACY_ACTIVITY",
        app: "niffler",
        at: Date.parse("2026-03-25T10:30:00Z"),
        actor: nikos,
        detail: {
            day: "2026-03-25",
            events: [{ id: "legacy-callback-1", type: "CALLBACK", at: Date.parse("2026-03-25T10:30:00Z"), detail: { schedule: "2026-03-26T08:00:00Z" }, text: "Θα ξανακαλέσω αύριο." }]
        }
    },
    {
        id: "activity-nikos-2026-03-24",
        type: "LEGACY_ACTIVITY",
        app: "niffler",
        at: Date.parse("2026-03-24T10:30:00Z"),
        actor: nikos,
        detail: {
            day: "2026-03-24",
            events: [{ id: "legacy-comment-2", type: "COMMENT", at: Date.parse("2026-03-24T10:30:00Z"), text: "Θα ξανακαλέσω αύριο." }]
        }
    },
    {
        id: "activity-unknown",
        type: "LEGACY_ACTIVITY",
        app: "niffler",
        at: null,
        actor: {},
        detail: {
            day: null,
            events: [{ id: "legacy-undated-note", type: "COMMENT", at: null, text: "Παλαιότερη σημείωση χωρίς καταγεγραμμένη ημερομηνία ή συντάκτη." }]
        }
    }
];
